import useMutationApi from 'src/api/useMutationApi';

const useLogOut = () => {
  return useMutationApi<void, void>({
    endpoint: 'auth/logout',
    method: 'POST',
    // Logging out has to work while imitating — the backend allowlists this
    // POST for the same reason. Without the opt-out the imitation write block
    // would strand the admin in the imitated session.
    options: { meta: { allowDuringImitation: true } },
  });
};

export default useLogOut;
